<template>
  <el-dialog title="Novo Representante" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="40%">
    <el-form :model="representante" :rules="validacao" ref="form" size="small" label-position="top" style="margin: -20px 0px 0px 0px" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Nome" prop="nome">
            <el-input v-model="representante.nome"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="CPF" prop="cpf">
            <el-input v-model="representante.cpf" v-mask="['###.###.###-##']"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="RG">
            <el-input v-model="representante.rg"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Profissão">
            <el-input v-model="representante.profissao"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Nacionalidade">
            <el-input v-model="representante.nacionalidade"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="adicionar" type="primary" size="small">Adicionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      validacao: {
        nome: [
          { type: "string", required: true, whitespace: true }
        ],
        cpf: [
          { type: "string", required: true, whitespace: true, len: 14 }
        ],
      },
      representante: {
        nome: undefined,
        cpf: undefined,
        rg: undefined,
        profissao: undefined,
        nacionalidade: undefined
      }
    }
  },  
  computed: {
    ...mapState('clientesStore', {
      cliente(state) { return state.clienteSelecionado },
      })
  },
  methods: {
    reset() {
      this.representante = {
        nome: undefined,
        cpf: undefined,
        rg: undefined,
        profissao: undefined,
        nacionalidade: undefined
      };
      this.$refs['form'].resetFields();
    },
    adicionar() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          let payload = {
            nome: this.representante.nome,
            cpf: this.representante.cpf,
            rg: this.representante.rg,
            profissao: this.representante.profissao,
            nacionalidade: this.representante.nacionalidade
          };

          this.cliente.representantes.push(payload);
          this.fechar();
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    fechar() {
      this.reset();
      this.$emit('close');
    }
  }
}
</script>

